<template>
  <div v-if="post">
    <PostContent
      :post="post"
      :is-disp-title="false"
    />

    <div class="block mt-6">
      <h3 class="title is-4">{{ $t('term.explanation') }}</h3>
      <html-content
        v-if="post.answerExplanation"
        class="column"
        :body="post.answerExplanationHtml"
      ></html-content>
      <EbImages
        :images="post.answerExpImages"
        :target-service-id="postServiceId"
      />
    </div>

    <nav
      class="breadcrumb"
      aria-label="breadcrumbs"
    >
      <ul v-if="'category' in post && post.category">
        <li>
          <router-link :to="`/posts/${postServiceId}/`">{{ $t('common.posts') }}</router-link>
        </li>
        <li v-for="parent in post.category.parents">
          <router-link :to="`/posts/${postServiceId}/categories/${parent.slug}`">{{
            parent.label
          }}</router-link>
        </li>
        <li>
          <router-link :to="`/posts/${postServiceId}/categories/${post.category.slug}`">{{
            post.category.label
          }}</router-link>
        </li>
      </ul>
    </nav>

    <ul v-if="'tags' in post && post.tags">
      <li
        v-for="tag in post.tags"
        class="is-inline-block mr-2"
      >
        <router-link
          :to="`/posts/${postServiceId}/tags/${tag.label}`"
          class="tag"
          >{{ tag.label }}</router-link
        >
      </li>
    </ul>
  </div>
</template>
<script>
import {Post} from '@/api'
import PostContent from '@/components/organisms/PostContent'
import HtmlContent from '@/components/atoms/HtmlContent'
import EbImages from '@/components/molecules/EbImages'

export default {
  name: 'Post',

  components: {
    PostContent,
    HtmlContent,
    EbImages,
  },

  data() {
    return {
      post: null,
    }
  },

  computed: {
    postId() {
      return this.$route.params.postId
    },

    postServiceId() {
      return this.post.serviceId
    },
  },

  async created() {
    await this.init()
  },

  methods: {
    async init() {
      await this.setPost(this.slug)
    },

    async setPost(slug) {
      this.$store.dispatch('setLoading', true)
      try {
        this.post = await Post.getDetailById(this.postId)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.debugOutput(err)
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },
  },
}
</script>
